import type { StateCreator } from 'zustand';

type DefaultValue = boolean;

type State<T = DefaultValue> = {
  allPagesSelected: boolean;
  selected: Record<string, T>;
};

type Actions<T = DefaultValue> = {
  setAllPagesSelected: (value: boolean) => void;
  setSelected: (data: Record<string, T>) => void;
  getSelectionState: () => State<T>;
  resetSelection: () => void;
};

export type TableSelectionSlice<T = DefaultValue> = State<T> & Actions<T>;

const initialState: TableSelectionSlice = {
  allPagesSelected: false,
  selected: {},
  getSelectionState: () => ({
    allPagesSelected: false,
    selected: {},
  }),
  resetSelection: () => undefined,
  setAllPagesSelected: () => undefined,
  setSelected: () => undefined,
};

export const createTableSelectionSlice: StateCreator<TableSelectionSlice> = (
  set,
  get
) => ({
  allPagesSelected: false,
  selected: {},
  setAllPagesSelected: (value) => {
    set((state) => ({
      ...state,
      allPagesSelected: value,
    }));
  },
  getSelectionState: () => {
    return get();
  },
  setSelected: (selected) => {
    set((state) => ({
      ...state,
      selected,
    }));
  },
  resetSelection: () => set(initialState),
});
